import React, { Fragment } from 'react'
import EditBtn from '../buttons/EditBtn'
import DeleteBtn from '../buttons/DeleteBtn'
import NullMssg from '../common/NullMssg'
import _ from 'lodash'
import { mssgs } from '../../constantes/mssgs'
import OpenBtn from '../buttons/OpenBtn'
import PlusBtn from '../buttons/PlusBtn'

const EventosList = ({
  allEventos,
  handleRemove,
  openEditModal,
  openViewModal,
  toViewLeads,
  openTaskModalWithEvent,
}) => {
  const eventosOrdered = _.orderBy(allEventos, ['fechaCreacion'], ['desc'])

  // Función para formatear fecha sin hora
  const formatDateWithoutTime = (dateString) => {
    if (!dateString) return '-'

    try {
      // Si la fecha ya está en formato YYYY-MM-DD, la devolvemos tal como está
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return dateString
      }

      // Si la fecha incluye hora, extraer solo la parte de la fecha
      if (dateString.includes(' ')) {
        return dateString.split(' ')[0]
      }

      // Si está en formato DD/MM/YYYY, convertir a YYYY-MM-DD
      if (dateString.includes('/')) {
        const [day, month, year] = dateString.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }

      return dateString
    } catch (error) {
      console.error('Error formatting date:', error)
      return dateString
    }
  }

  const handleRowClick = (e, evento) => {
    // Evitar que el clic en los botones internos dispare esta función
    if (
      e.target.tagName.toLowerCase() === 'button' ||
      e.target.closest('button')
    ) {
      return
    }

    // Abrir modal en modo view
    if (openViewModal && evento) {
      openViewModal(evento)
    }
  }

  return (
    <>
      <Fragment>
        <div className='table-wrapper'>
          {eventosOrdered && eventosOrdered.length > 0 ? (
            <table className='eventos-table'>
              <thead>
                <tr>
                  <th className="table-th-date">
                    F.Creación
                  </th>
                  <th style={{ minWidth: '100px', width: '24%'}}>
                    Nombre
                  </th>
                  <th className="table-th-date">
                    F.Inicio
                  </th>
                  <th className="table-th-date">
                    F.Fin
                  </th>
                  <th style={{ minWidth: '100px', width: '16%'}}>
                    Descripción
                  </th>
                  <th style={{ minWidth: '100px', width: '16%'}}>
                    Ubicación
                  </th>
                  <th className="table-th-calendar">
                    Calendario?
                  </th>
                  <th className="table-th-actions" style={{ width: '220px', minWidth: '220px'}}>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {eventosOrdered &&
                  eventosOrdered.map((evento, i) => (
                    <tr
                      onClick={(e) => handleRowClick(e, evento)}
                      key={evento.id_Evento || i}
                      style={{ cursor: 'pointer' }}
                    >
                      <td>
                          {formatDateWithoutTime(
                            evento && evento.fechaCreacion,
                          )}
                      </td>
                      <td className="table-td-header">
                          {evento && evento.nombre}
                      </td>
                      <td>
                        {formatDateWithoutTime(evento && evento.fechaInicio)}
                      </td>
                      <td>
                        {formatDateWithoutTime(evento && evento.fechaFinal)}
                      </td>
                      <td className="table-td-ellipsis">
                        {evento && evento.descripcion}
                      </td>
                      <td className="table-td-ellipsis">
                        {evento && evento.ubicacion}
                      </td>
                      <td className="table-td-calendar">
                        {evento && evento.isVerCaledario ? 'Sí' : ''}
                      </td>
                      <td className="table-td-actions">
                        <button
                          onClick={() => toViewLeads(evento.id_Evento)}
                          title='Ver leads'
                          className='action-button'
                        >
                          <span>{evento?.numLeads}</span>
                          <OpenBtn fill='#ED8B00' />
                        </button>
                        <button
                          onClick={() =>
                            openTaskModalWithEvent(evento.id_Evento)
                          }
                          title='Crear lead'
                          className='action-button'
                        >
                          <PlusBtn />
                        </button>
                        <button onClick={() => openEditModal(evento)}>
                          <EditBtn />
                        </button>
                        <button
                          onClick={() => handleRemove(evento.id_Evento)}
                        >
                          <DeleteBtn />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_EVENTO} />
          )}
        </div>
      </Fragment>
    </>
  )
}

export default EventosList
